/**
 * Custom hook for managing About page data
 * Provides static data for the About page components
 */

export interface CoreValue {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

export interface DetailedValue {
  id: string;
  title: string;
  description: string;
}

export interface AboutPageData {
  headerTitle: string;
  headerSubtitle: string;
  headerBackgroundImage: string;
  coreValues: CoreValue[];
  detailedValuesTitle: string;
  detailedValuesSubtitle: string;
  detailedValuesImage: string;
  detailedValuesImageAlt: string;
  detailedValues: DetailedValue[];
}

export const useAboutPageData = (): AboutPageData => {
  return {
    headerTitle: "Về chúng tôi",
    headerSubtitle: "Kiến tạo Xanh toả sáng tâm hồn Việt",
    headerBackgroundImage: "/header_90ad.png",
    
    coreValues: [
      {
        id: "vision",
        title: "Tầm nhìn",
        description: "Đổi mới không ngừng - Phát triển bền vững - Khẳng định vị thế: Kiến tạo Xanh Việt.",
        imageSrc: "/tamnhin_9332.png",
        imageAlt: "Kiến tạo Xanh - Tầm nhìn"
      },
      {
        id: "mission",
        title: "Sứ mệnh",
        description: "Tiên phong kiến tạo - Nâng tầm giá trị - Nâng tầm cuộc sống.",
        imageSrc: "/sumenh_23.jpg",
        imageAlt: "Kiến tạo Xanh - Sứ mệnh"
      },
      {
        id: "core-values",
        title: "Giá trị cốt lõi",
        description: "TẤM – TIN – TRÍ – NHÂN – NGHĨA",
        imageSrc: "/GiaTriCotLoi_d84b.png",
        imageAlt: "Kiến tạo Xanh - Giá trị cốt lõi"
      }
    ],
    
    detailedValuesTitle: "TẤM – TÍN – TRÍ – NHÂN – NGHĨA",
    detailedValuesSubtitle: "Kiến tạo Xanh luôn toả sáng Tâm hồn Việt.",
    detailedValuesImage: "/picture1_71d8.png",
    detailedValuesImageAlt: "NET ZERO sustainable city concept",
    
    detailedValues: [
      {
        id: "tam",
        title: "Tâm",
        description: "TẤM là Tâm trí, Tâm thức, Tâm hồn: là cội nguồn của sức mạnh – là gốc rễ của giá trị. Mọi suy nghĩ, mọi hành động của chúng tôi đều bắt nguồn từ Tâm hồn. Tâm thật để thấu hiểu. Tâm công để sáng tạo. Tâm trong để lắng kết. Mỗi sản phẩm, mỗi dịch vụ là sự kết tinh tinh hoa nhất, chất lọc nhất từ tâm hồn của chúng tôi: Kiến Tạo Xanh Group."
      },
      {
        id: "tin",
        title: "Tín",
        description: "TÍN là Tín nhiệm - là Tín cậy. Chữ Tín là cái chúng tôi luôn trao đi trong các mối quan hệ với khách hàng, với bạn hàng, với đối tác, với chính phủ, với cộng đồng, với xã hội để chúng tôi luôn nhận được sự Tín nhiệm. Tín cậy mãi mãi của mọi người. Tín là trách nhiệm - là Danh dự - là giá trị cốt lõi sống còn của Kiến tạo Xanh Group."
      },
      {
        id: "tri",
        title: "Trí",
        description: "TRÍ là Trí tuệ cùng là Trí huệ mà chúng tôi luôn miệt mài nghiên cứu, đổi mới không ngừng tạo ra sản phẩm, dịch vụ ngày càng chất lượng hơn, giá trị hơn. Trí tuệ là tài sản trí thức cầu thành giá trị cốt lõi nên chúng tôi luôn tích cóp, giữ gìn và bảo vệ."
      },
      {
        id: "nhan",
        title: "Nhân",
        description: "NHÂN là Nhân văn - Nhân bản. Trác ẩn, thấu hiểu, sẻ chia, nâng đỡ, đồng lòng, trách nhiệm vừa là lẽ sống vừa là niềm vui, vừa là hạnh phúc của mỗi cá nhân cũng như tập thể Kiến tạo Xanh luôn luôn hành động vì một bản sắc văn hóa Việt nhân bản, trường tồn."
      },
      {
        id: "nghia",
        title: "Nghĩa",
        description: "NGHĨA là Nghĩa cử - là hành động của chúng tôi luôn hướng đến cộng đồng vì một môi trường Xanh tươi hơn - Bền vững hơn. Chúng tôi cam kết đồng hành cùng Chính phủ, cùng các nhà hảo tâm, cùng cộng đồng hành động vì một Việt nam cộng đằng hơn, nhân ái hơn, hạnh phúc hơn. Kiến tạo Xanh luôn toả sáng Tâm hồn Việt."
      }
    ]
  };
};
